import axios from 'axios';
import { API } from '../../../config/api';

const http = axios.create({
  baseURL: API.BACKEND,
  timeout: 10000
});

// `axios.create()` snapshots the global defaults, so a token written later by
// `setAuthToken` never reaches this instance. See features/jobs/api/http.js.
http.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['x-auth-token'] = token;
  }
  return config;
});

export async function fetchMaterialSpecs({ usedIn, material, q, includeInactive } = {}) {
  const params = {};
  if (usedIn) params.usedIn = usedIn;
  if (material) params.material = material;
  if (q) params.q = q;
  if (includeInactive) params.includeInactive = true;

  const { data } = await http.get('/api/v1/material-specs', { params });
  return data?.data || [];
}

export async function createMaterialSpec(body) {
  const { data } = await http.post('/api/v1/material-specs', body);
  return data?.data;
}

export async function updateMaterialSpec(id, body) {
  const { data } = await http.put(`/api/v1/material-specs/${id}`, body);
  return data?.data;
}

export async function deleteMaterialSpec(id) {
  const { data } = await http.delete(`/api/v1/material-specs/${id}`);
  return data;
}

export async function mergeMaterialSpec(id, intoId) {
  const { data } = await http.post(`/api/v1/material-specs/${id}/merge`, { intoId });
  return data?.data;
}
